import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from '@atlaskit/react-select';
export function Input(props) {
  var _ariaDescribedByAttri;
  var ariaDescribedByAttribute = props['aria-describedby'];
  var passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
  if (passed_describedby && !((_ariaDescribedByAttri = ariaDescribedByAttribute) !== null && _ariaDescribedByAttri !== void 0 && _ariaDescribedByAttri.includes(passed_describedby))) {
    ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
  } else {
    ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
  }
  return /*#__PURE__*/React.createElement(components.Input, _extends({}, props, {
    "aria-describedby": ariaDescribedByAttribute
  }));
}